import React, { useEffect } from "react";
import { MapContainer, TileLayer, Circle, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

const HOUSTON_CENTER = [29.7604, -95.3698];
const RADIUS_METERS = 100 * 1609.34;

const goldIcon = new L.Icon({
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const LIGHT_TILES = "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";
const TILES_ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>';

export function ServiceAreaMap() {
  return (
    <MapContainer
      center={HOUSTON_CENTER}
      zoom={8}
      scrollWheelZoom={false}
      style={{ height: "100%", width: "100%", borderRadius: "16px" }}
      className="z-0"
    >
      <TileLayer attribution={TILES_ATTR} url={LIGHT_TILES} />
      <Circle
        center={HOUSTON_CENTER}
        radius={RADIUS_METERS}
        pathOptions={{ color: "#D4AF37", fillColor: "#D4AF37", fillOpacity: 0.1, weight: 2 }}
      />
      <Marker position={HOUSTON_CENTER} icon={goldIcon}>
        <Popup><strong>Houston Pro Locksmith</strong><br />Service Area: 100 miles</Popup>
      </Marker>
    </MapContainer>
  );
}

function MapClickHandler({ onLocationSelect }) {
  const map = useMap();
  useEffect(() => {
    const handleClick = (e) => onLocationSelect(e.latlng.lat, e.latlng.lng);
    map.on("click", handleClick);
    return () => map.off("click", handleClick);
  }, [map, onLocationSelect]);
  return null;
}

export function LocationPickerMap({ selectedLat, selectedLng, onLocationSelect }) {
  return (
    <MapContainer
      center={HOUSTON_CENTER}
      zoom={10}
      scrollWheelZoom={true}
      style={{ height: "100%", width: "100%", borderRadius: "12px" }}
      className="z-0"
    >
      <TileLayer attribution={TILES_ATTR} url={LIGHT_TILES} />
      <Circle
        center={HOUSTON_CENTER}
        radius={RADIUS_METERS}
        pathOptions={{ color: "#D4AF37", fillColor: "#D4AF37", fillOpacity: 0.05, weight: 1, dashArray: "5, 10" }}
      />
      <MapClickHandler onLocationSelect={onLocationSelect} />
      {selectedLat && selectedLng && (
        <Marker position={[selectedLat, selectedLng]} icon={goldIcon}>
          <Popup>Your location</Popup>
        </Marker>
      )}
    </MapContainer>
  );
}
